(function () {

  function initCollectionSliders(scope) {
    if (typeof Swiper === 'undefined') {
      return;
    }
    const root = scope || document;
    root
      .querySelectorAll('.js-collection-cards-slider')
      .forEach(function (slider) {
        if (slider.swiper) {
          slider.swiper.destroy(
            true,
            true
          );
        }
        const slides =
          slider.querySelectorAll(
            '.swiper-slide'
          );
        const prev =
          slider.querySelector(
            '.swiper-button-prev-custom'
          );
        const next =
          slider.querySelector(
            '.swiper-button-next-custom'
          );
        const pagination =
          slider.querySelector(
            '.swiper-pagination-custom'
          );
        if (!slides.length) {
          return;
        }
        const width = window.innerWidth;
        const isDesktop =
          width >= 1280;
        if (
          isDesktop &&
          slides.length <= 4
        ) {
          slider.classList.add(
            'collection-slider-static'
          );
          if (prev) {

            prev.style.display =
              'none';

          }
          if (next) {
            next.style.display =
              'none';
          }
          if (pagination) {
            pagination.style.display =
              'none';
          }
          return;
        }

        slider.classList.remove(
          'collection-slider-static'
        );
        if (prev) {
          prev.style.display = '';
        }
        if (next) {
          next.style.display = '';
        }
        if (pagination) {
          pagination.style.display = '';
        }
        new Swiper(
          slider,
          {
            slidesPerView: 1,
            spaceBetween: 15,
            speed: 500,
            watchOverflow: false,
            grabCursor: true,
            navigation: {
              prevEl: prev,
              nextEl: next
            },
            pagination: {
              el: pagination,
              clickable: true
            },
            breakpoints: {
              750: {
                slidesPerView: 2,
                spaceBetween: 20
              },
              990: {
                slidesPerView: 3,
                spaceBetween: 20
              },
              1280: {
                slidesPerView: 4,
                spaceBetween: 24
              }
            }
          }
        );
      });
  }

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      initCollectionSliders(
        document
      );
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initCollectionSliders(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:reorder',
    function () {
      initCollectionSliders(
        document
      );
    }
  );

  document.addEventListener(
    'shopify:section:select',
    function (event) {
      initCollectionSliders(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:deselect',
    function (event) {
      initCollectionSliders(
        event.target
      );
    }
  );

  let resizeTimer;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(
        resizeTimer
      );
      resizeTimer =
        setTimeout(
          function () {
            initCollectionSliders(
              document
            );
          },
          150
        );
    }
  );

})();